import { addDiastereotopicMissingChirality } from 'openchemlib-utils';
import { buildAssignments, } from './utils/getAssignment/buildAssignments';
import { checkIDs } from './utils/getAssignment/checkIDs';
import { getTargetsAndCorrelations } from './utils/getAssignment/getTargetsAndCorrelations';
import getWorkFlow from './utils/getAssignment/getWorkFlow';
export async function getAssignments(input, options = {}) {
    let { restrictionByCS = {}, justAssign, minScore = 1, maxSolutions = 10, nbAllowedUnAssigned, timeout = 6000, predictionOptions = {}, predictions = {}, correlation: correlationOptions = {}, } = options;
    const { tolerance = { H: 0.2, C: 1 }, useChemicalShiftScore = false, chemicalShiftRestriction = true, } = restrictionByCS;
    const molecule = input.molecule;
    if (!molecule)
        throw new Error('It is needed a molecule to assign');
    molecule.addImplicitHydrogens();
    addDiastereotopicMissingChirality(molecule);
    const spectra = checkIDs(input.spectra);
    const { targets, correlations } = getTargetsAndCorrelations(spectra, correlationOptions);
    const { assignmentOrder } = getWorkFlow(correlations, justAssign);
    const solutions = await buildAssignments({
        restrictionByCS: {
            tolerance,
            useChemicalShiftScore,
            chemicalShiftRestriction,
        },
        spectra,
        molecule,
        timeout,
        minScore,
        maxSolutions,
        assignmentOrder,
        nbAllowedUnAssigned,
        correlations,
        targets,
        predictionOptions,
        predictions,
    });
    return solutions;
}
//# sourceMappingURL=getAssignments.js.map